<span
  class="nav-item"
  [ngClass]="{ active: this.active, inactive: !this.active }"
  (click)="this.navigate()"
>
  <img *ngIf="active" class="item-icon" src="{{ active_url }}" alt="" />
  <img *ngIf="!active" class="item-icon" src="{{ url }}" alt="" />
  <span *ngIf="!this.isCollapsed" class="label">{{
    label.replace("-", " ")
  }}</span>
</span>
